module.exports = __webpack_public_path__ + "fff44e0589ae4352e6be193734d4fe23.pdf";